export default __webpack_public_path__ + "static/media/returns.inline.4243d746.svg";